import React from "react"
import { ButtonBase } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledButton = styled(ButtonBase)({
  backgroundColor: "#3374DA",
  "&:hover": {
    backgroundColor: "#2A5FB3",
  },
  "&:disabled": {
    backgroundColor: "#DDD",
  },
  width: "90%",
  height: "55px",
  fontFamily: "HiraKakuProN-W6, Hiragino Kaku Gothic ProN",
  fontSize: "16px",
  color: "#FFF",
  fontWeight: 600,
  borderRadius: "3px",
})

const ModalDisabledAgreementButton = ({
  id,
  handleClickButton,
  disabled,
  value,
  ga,
}) => {
  return (
    <StyledButton
      id={id}
      disabled={disabled}
      onClick={handleClickButton}
      data-ga={ga}
    >
      {value}
    </StyledButton>
  )
}

export default ModalDisabledAgreementButton
